import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { CLUB_EVENT_LIST, GLOBAL_STATE } from '../constants/actionTypes'

const clubEventSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const clubEventListSelector = createSelector(clubEventSelector, data => data[CLUB_EVENT_LIST])
